module.exports = __webpack_public_path__ + "img/search.043af43b.svg";